import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, Instagram, Facebook, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { SITE, waGeneral } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";

const Footer = () => (
  <footer className="bg-[#0F2F24] text-[#FAF7F2]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <div className="mb-4">
          <Logo dark className="h-10" />
        </div>
        <p className="text-sm text-[#FAF7F2]/70 leading-relaxed">
          Carefully planned, personalised Kashmir holidays for Indian travellers — Srinagar, Gulmarg, Pahalgam, Sonamarg and beyond.
        </p>
      </div>

      <nav aria-label="Footer navigation">
        <h3 className="font-serif text-lg font-semibold mb-4">Explore</h3>
        <ul className="space-y-2 text-sm text-[#FAF7F2]/75">
          {[["Home", "/"], ["Kashmir Packages", "/kashmir-tour-packages"], ["Honeymoon", "/kashmir-honeymoon-packages"],
            ["Family Holidays", "/kashmir-family-packages"], ["Itineraries", "/kashmir-itineraries"],
            ["About Us", "/about-us"], ["Why You'll Love Us", "/why-youll-love-us"],
            ["Contact", "/contact-us"]].map(([label, to]) => (
            <li key={to}><Link to={to} className="hover:text-[#D99B26] transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</Link></li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Policies">
        <h3 className="font-serif text-lg font-semibold mb-4">Policies</h3>
        <ul className="space-y-2 text-sm text-[#FAF7F2]/75">
          <li><Link to="/privacy-policy" className="hover:text-[#D99B26] transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          <li><Link to="/terms-and-conditions" className="hover:text-[#D99B26] transition-colors" data-testid="footer-link-terms">Terms &amp; Conditions</Link></li>
          <li><Link to="/cancellation-refund-policy" className="hover:text-[#D99B26] transition-colors" data-testid="footer-link-cancellation">Cancellation &amp; Refund Policy</Link></li>
        </ul>
        <p className="mt-6 text-xs text-[#FAF7F2]/50 flex items-start gap-1.5">
          <MapPin className="h-3.5 w-3.5 mt-0.5 shrink-0" /> {SITE.address}
        </p>
      </nav>

      <div>
        <h3 className="font-serif text-lg font-semibold mb-4">Talk to Us</h3>
        <ul className="space-y-3 text-sm">
          <li>
            <a href={`tel:${SITE.phoneRaw}`} onClick={() => trackEvent("phone_click", { location: "footer" })} data-testid="footer-phone-link"
              className="flex items-center gap-2 text-[#FAF7F2]/85 hover:text-[#D99B26] transition-colors">
              <Phone className="h-4 w-4 text-[#D99B26]" /> {SITE.phoneDisplay}
            </a>
          </li>
          <li>
            <a href={waGeneral()} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent("whatsapp_click", { location: "footer" })} data-testid="footer-whatsapp-link"
              className="flex items-center gap-2 text-[#FAF7F2]/85 hover:text-[#D99B26] transition-colors">
              <MessageCircle className="h-4 w-4 text-[#D99B26]" /> WhatsApp: {SITE.phoneDisplay}
            </a>
          </li>
          <li>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email-link"
              className="flex items-center gap-2 text-[#FAF7F2]/85 hover:text-[#D99B26] transition-colors">
              <Mail className="h-4 w-4 text-[#D99B26]" /> {SITE.email}
            </a>
          </li>
        </ul>
        <div className="mt-5 flex gap-3">
          <a href={SITE.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-[#D99B26] hover:text-[#0F2F24] transition-colors">
            <Instagram className="h-4 w-4" />
          </a>
          <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-[#D99B26] hover:text-[#0F2F24] transition-colors">
            <Facebook className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-[#FAF7F2]/50" data-testid="footer-copyright">
        © {new Date().getFullYear()} Book Kashmir. All Rights Reserved. | {SITE.domain}
      </p>
    </div>
  </footer>
);

export default Footer;
